import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../common/components/Dialog';
import { withTranslation } from 'react-i18next';
import { Image } from 'react-bootstrap';
import ui from '../../common/services/ui';

class TeacherDetailsLink extends Component {
	constructor(props) {
		super(props);
		this.showInfoDialog = this.showInfoDialog.bind(this);
		this.hideInfoDialog = this.hideInfoDialog.bind(this);
		this.state = {
			showInfoDialog: false
		};
	}

	showInfoDialog() {
		this.setState({
			showInfoDialog: true
		});
	}

	hideInfoDialog() {
		this.setState({
			showInfoDialog: false
		});
	}

	renderInfoDialog() {
		const { teacher } = this.props;
		const avatarStyle = { width: 200, height: 200, lineHeight: '200px', fontSize: 45, display: 'inline-block', textAlign: 'center' };

		const header = teacher && teacher.name;
		const body = teacher && <div>
			<div style={{ textAlign: 'center', padding: '20px' }}>
				{teacher.photoUrl ? <Image className={'circle-icon'} width={200} height={200} src={teacher.photoUrl} alt={teacher.name} /> :
					<div className={'circle-icon text-white bg-purple'} style={avatarStyle}>{ui.getAvatarName(teacher.firstName, teacher.lastName)}</div>}
			</div>
			<div>
				<p>{teacher.bio}</p>
			</div>
		</div>;

		return <Dialog show={this.state.showInfoDialog} onHide={this.hideInfoDialog} header={header} body={body} />;
	}

	render() {
		const { teacher } = this.props;
		const infoDialog = this.renderInfoDialog();

		return teacher ? <span>
			<a style={{ cursor: 'pointer' }} onClick={this.showInfoDialog}>{teacher.name}</a>
			{infoDialog}
		</span> : null;
	}
}

TeacherDetailsLink.propTypes = {
	teacher: PropTypes.shape({
		name: PropTypes.string,
		bio: PropTypes.string,
		photoUrl: PropTypes.string
	})
};

export default withTranslation()(TeacherDetailsLink);